var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.columns.length)?_c('Table',{attrs:{"bordered":true,"data":_vm.tableData,"columns":_vm.columns,"recordsTotal":_vm.recordsTotal,"page-size":_vm.recordsTotal,"canFilter":false,"hide-remove-buttons":true,"showMoreOptions":false}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }